import React from 'react';
import PropTypes from 'prop-types';
import Chart from 'chart.js/auto';
import {CategoryScale} from 'chart.js';
import {Pie} from 'react-chartjs-2';
import './pie-chart.scss';

const PieChart = ({type, values, labels = [], deviceInfo}) => {
	const colors = ['#410528', '#FCB944', '#D35241', '#A3D7E2', '#82C484', '#ffffff'];

	Chart.register(CategoryScale);
	const chartData = {labels: labels, datasets: [{data: values, backgroundColor: colors}]};
	const options = {
		plugins: {
			tooltip: {
				callbacks: {
					label: function(tooltipItem) {
						return tooltipItem.formattedValue + '%';
					}
				}
			},
		},
	};

	return (
		<div className={'PieChart' + (type ? ' ' + type : '') + ' ' + deviceInfo.orientation}>
			<Pie data={chartData} options={options} />
		</div>
	);
};

PieChart.propTypes = {
	type: PropTypes.string,
	values: PropTypes.array.isRequired,
	labels: PropTypes.array,
	deviceInfo: PropTypes.object.isRequired
};

export default PieChart;